module.exports = __webpack_public_path__ + "static/media/ic_chevron_right_white_24px.fbba8092.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/misc/svg/ic_chevron_right_white_24px.svg
// module id = 404
// module chunks = 0